import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import _ from "underscore";

var CurrentUser = require("lib/account/CurrentUser");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var Spinner = require("components/utility/Spinner");
var MergeUsersForm = require("components/users/shared/MergeUsersForm")
var MergeStudentListsForm = require("components/users/shared/MergeStudentListsForm")

@connect(
  (state, props) => {
    var id = CurrentUser.get().id
    return {
      admin: RosterSelectors.admin({ state, id }),
      students: RosterSelectors.students({ state }),
    }
  },
  (dispatch, props) => {
    var userID = CurrentUser.get().id
    return {
      populateData: () => {
        return dispatch(RosterActions.fetchAdmins({
          filter: { id: userID },
          embeds: ["admin.student_lists", "student_list.students", "admin.related_users", "user.link_suggestion"]
        }))
      },
      mergeAccounts: function (params) {
        return dispatch(RosterActions.postUserTrigger(userID, params))
      },
      fetchAdmin: function (userID) {
        return dispatch(RosterActions.fetchAdmins({
          filter: { id: userID },
          embeds: ["admin.student_lists", "student_list.students", "admin.related_users", "user.link_suggestion"]
        }))
      }
    }
  }
)
@providePopulateData({ waitForLoad: true })
class MergeAccountsPreferences extends React.Component {
  constructor(props) {
    super()
    autobind(this)
    this.state = {
      loading: false,
      dupUserIDs: [],
      dupSLIDs: [],
      studentMergeLoading: false,
      slMergeLoading: false
    }

    this.mergUsersModal = React.createRef();
    this.mergeStudentListModal = React.createRef();

    LuckyOrangeClient.tagComponent("MergeAccountsPreferences");
  }

  ///////// HELPERS /////////
  relatedUsersLookup(conditions) {
    var { admin } = this.props
    return conditions ? _.where(admin.related_users, conditions) : admin.related_users
  }

  dupUserIDs() {
    var conditions = { merged_students: false }
    if (!_.isEmpty(this.relatedUsersLookup(conditions))) {
      return _.flatten(_.map(this.relatedUsersLookup(), (user) => { return user.student_ids }))
    } else {
      return false
    }
  }

  userIDs() {
    var conditions = { merged_students: false }
    var allUserIDs = _.map(this.props.students, (student) => { return student.id })
    return !_.isEmpty(this.relatedUsersLookup()) ? allUserIDs.filter((id) => !this.dupUserIDs(conditions).includes(id)) : allUserIDs
  }

  refreshUserProps() {
    this.setState({ loading: true })
    this.props.fetchAdmin(this.props.admin.id).then(() => {
      this.setState({ loading: false })
    })
  }

  ///////////////////////////

  ///// EVENT HANDLERS /////
  handleMergeSLSubmit(e) {
    $wr.nope(e)
    this.refreshUserProps()
  }

  handleMergeStudentsSubmit(e) {
    $wr.nope(e)
    this.refreshUserProps()
  }
  //////////////////////////

  //// RENDER METHODS /////
  renderLinkedAccounts() {
    if (!_.isEmpty(this.relatedUsersLookup())) {
      var related_users = _.map(this.props.admin.related_users, user => {
        return (
          <span className='relatedUserDisplay' key={'related_user-' + user.id}>
            <strong>{user.first_name} {user.last_name}</strong> (username: {user.username})
          </span>
        )
      })
      return (
        <div className='linkedAccountsContainer'>
          <div className='linkedAccountText'>This account is linked with the following accounts:</div>
          {related_users}
        </div>
      )
    }
  }

  renderForm() {
    var unMergedStudents = { merged_students: false }
    var unMergedStudentLists = { merged_student_lists: false }

    if (this.state.loading) {
      return <Spinner placeholder={true} scale={1.7} />
    } else if (_.isEmpty(this.relatedUsersLookup())) {
      var content = (
        <div className='accountSyncFormContainer'>
          <div className='accountSyncInstructions'>Your account is not linked with another account. First, please <a href='/settings/link-accounts'>link an account</a>.</div>
        </div>
      )
    } else if (!_.isEmpty(this.relatedUsersLookup(unMergedStudents))) {
      var content = <MergeUsersForm userIDs={this.userIDs()} duplicateUserIDs={this.dupUserIDs()} mergeType={'student'} afterSubmit={this.handleMergeStudentsSubmit} />
    } else if (!_.isEmpty(this.relatedUsersLookup(unMergedStudentLists))) {
      var content = <MergeStudentListsForm afterSubmit={this.handleMergeSLSubmit} />
    } else {
      var content = (
        <div className='accountSyncFormContainer'>
          <div className='accountSyncInstructions'><b>All user data is merged</b></div>
        </div>
      )
    }
    return content
  }

  //////////////////////////

  render() {
    return (
      <div className='accountSyncContainer'>
        {this.renderLinkedAccounts()}
        {this.renderForm()}
      </div>
    );
  }
}

MergeAccountsPreferences.WrappedComponent.propTypes = PageStrictPropTypes({
  //signed in admin
  admin: PropTypes.object,
  students: PropTypes.array,

  populateData: PropTypes.func,
  mergeAccounts: PropTypes.func,
  fetchAdmin: PropTypes.func,
})

module.exports = MergeAccountsPreferences;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/MergeAccountsPreferences.js